import styles from "../../../pages/signUp/otpVerification/OtpVerification.module.scss";
import { Alert, Button } from "antd";
import PinInput from "react-pin-input";
import React, { useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReduxStoreModel } from "../../../../interfaces/redux-interface";
import { updateBorrowerDetailsAction } from "../../../../redux/actions";
import { postData } from "../../../../apis/apiMethods";
import { apiEndpoints } from "../../../../apis/apiEndpoints";
import { appInsights } from "../../../../components/AppInsight/AppInsight";
import { MixPanel } from "../../../../helpers/mixpanel";
import { OtpUseType, ProductDomainEnum } from "../../../../helpers/enums";
import { errorHandler } from "../../../../helpers/errorHandler";

const VerifyPhoneNumber = () => {
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const pinInputRef = useRef<PinInput>(null);
  const dispatch = useDispatch();

  const borrowerData = useSelector(
    (state: ReduxStoreModel) => state.borrowerDetailsReducer,
  );

  const handleResendOtp = async () => {
    try {
      const payload = {
        email: borrowerData?.email,
        bvn: borrowerData?.bvn_number,
        partner: borrowerData?.aggregator_name,
        phone: borrowerData?.borrower_phone,
        countryCode: borrowerData?.country ?? borrowerData?.country_code,
        productDomain: ProductDomainEnum.EmbedLite,
        otpType: OtpUseType.AddOrUpdateCustomerOtherBankAccount,
        isValidatePhoneNumber: true,
      };
      await postData(apiEndpoints.validate_sign_up_email_and_phone, payload);
      dispatch(updateBorrowerDetailsAction({ phoneVerificationError: "" }));
    } catch (err) {
      dispatch(
        updateBorrowerDetailsAction({
          phoneVerificationError: err.response?.data?.message,
        }),
      );
      console.log(err);
    }
  };

  const handleSubmit = async () => {
    setError("");
    setSuccess("");
    setOtpLoading(true);
    try {
      const reqBody = {
        otp,
        email: borrowerData?.email,
        phone: borrowerData?.borrower_phone,
        isValidatePhoneNumber: true,
        otpType: OtpUseType.LoanApplication,
        productDomain: ProductDomainEnum.EmbedLite,
      };
      await postData(apiEndpoints.validate_sign_up_otp, reqBody);
      dispatch(
        updateBorrowerDetailsAction({
          isPhoneNumberVerified: true,
        }),
      );
      setOtpLoading(false);
    } catch (error) {
      setOtpLoading(false);
      pinInputRef.current?.clear();
      setError(errorHandler(error));
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "PhoneOtpVerification.tsx",
        },
      });

      MixPanel.track("Verify Phone number", {
        distinct_id: `${borrowerData?.email}`,
        URL: window.location.href,
        product: "Embed Web",
        status: `Failed: ${error.response?.data?.message ?? error.message}`,
        step: "PhoneOtpVerification.tsx",
      });
    }
  };

  return (
    <div className={styles.stepTwo_container}>
      {error || borrowerData?.phoneVerificationError ? (
        <div className={styles.errAlert}>
          <Alert
            message={error || borrowerData?.phoneVerificationError}
            type="error"
            showIcon
            closable
            onClose={() => {
              setError("");
              dispatch(
                updateBorrowerDetailsAction({
                  phoneVerificationError: "",
                }),
              );
            }}
          />
        </div>
      ) : success ? (
        <div className={styles.errAlert}>
          <Alert
            message={success}
            type="success"
            showIcon
            closable
            onClose={() => setSuccess("")}
          />
        </div>
      ) : null}

      <header className={styles.stepTwo_header}>
        <h1>Kindly verify your phone number</h1>
        <p>
          A One-Time password (OTP) has been sent to{" "}
          <strong className={styles.highlight}>
            {borrowerData?.borrower_phone}
          </strong>
        </p>
      </header>

      <div className={styles.stepTwo_form}>
        <div>
          <PinInput
            ref={pinInputRef}
            length={6}
            initialValue=""
            secret
            secretDelay={100}
            focus
            onChange={(value, index) => {
              setOtp(value);
            }}
            type="numeric"
            inputMode="number"
            autoSelect={true}
            regexCriteria={/^[ 0-9]*$/}
          />
        </div>

        <Button
          htmlType="button"
          onClick={handleResendOtp}
          loading={otpLoading}
          className={styles.resendOtp}
        >
          {otpLoading ? "Sending..." : "Resend OTP"}
        </Button>

        <Button
          type="primary"
          htmlType="submit"
          className={styles.submit_button}
          disabled={otpLoading || otp.length < 6}
          onClick={handleSubmit}
        >
          Validate
        </Button>
      </div>
    </div>
  );
};

export default VerifyPhoneNumber;
